import { Box, Tooltip } from "@mui/material";

export default function UserClientItem(props: {
  title: string;
  isSelected: boolean;
  onClick: () => void;
}) {
  const { title, isSelected, onClick } = props;
  return (
    <Tooltip title={title}>
      <Box
        onClick={onClick}
        sx={{
          overflow: "hidden",
          overflowWrap: "break-word",
          textOverflow: "ellipsis",
          WebkitLineClamp: 1,
          whiteSpace: "nowrap",
          backgroundColor: isSelected ? "rgba(217, 217, 217, 0.1)" : "none",
          padding: "8px 25px",
          borderRadius: "12px",
          cursor: "pointer",
          maxWidth: "250px",
          maxLines: 1,
        }}
      >
        {title}
      </Box>
    </Tooltip>
  );
}
